// Career Paths
export let LogoName = "/logo.png"
export let CompanyTitle = "CareerPaths"
export let CompanyWebsite = "https://careerpaths.io/"
export let CompanyHelpEmail = "help@careerpaths.io"
export let CompanySafetyEmail = "hello@careerpaths.io"
